import { downloadBinaryFile } from "../utils";

import { useDownloadDocumentMutation } from "./useDocumentsApi";

export function useDownloadDocument(): {
  downloadDocument: (downloadUrl: string, fileName: string) => Promise<void>;
} {
  const { mutateAsync } = useDownloadDocumentMutation();

  return {
    downloadDocument: async (
      downloadUrl: string,
      fileName: string,
    ): Promise<void> => {
      const blob = await mutateAsync({ downloadUrl });
      downloadBinaryFile(blob, fileName);
    },
  };
}
